export default {
  'landing.memory': 'Crea i tuoi ricordi con noi',
  'landing.family': 'Vivi i migliori viaggi con la tua famiglia e i tuoi amici',
  'landing.providing':
    'Fornire tutti i voli e il processo più semplice di ricerca, acquisto e rimborso dei biglietti aerei',
  'landing.price':
    'Il prezzo più basso per acquistare biglietti aerei con uno sconto speciale',
  'landing.point': 'Guadagna punti con ogni viaggio',
  'landing.buynow': 'Acquista ora',
  'landing.scotland': 'Viaggio in Scozia',
  'landing.ireland': 'Viaggio in Irlanda',
  'landing.Egypt': 'Viaggio in Egitto',
  'landing.greece': 'Viaggio in Grecia',
  'landing.person': 'alcune persone se ne sono andate',
  'landing.categories': 'Categorie',
};
